import BaseApi from './baseApi';
import ITransformation from '../models/ITransformations';
import IAuthentication from '../models/IAuthentication';
import { EMPTY_GUID } from '../../config/constants';
export default class TransformationApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Transformations");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async CompleteTransformation(idTransformation: string) : Promise<boolean> {
        let json : string = this.getJsonCompleteTransformation(idTransformation);
        const response = await this.api.post('exec', json);
        return this.isSuccess(response);
    }

    async GetTransformations(idCompany: string) : Promise<ITransformation[]> {
        let json : string = "";
        if (idCompany === EMPTY_GUID) {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithIdCompany(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var transformations: ITransformation[] = [];
            transformations = response.data as ITransformation[];
            return transformations;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetTransformationsCompleted(idCompany: string) : Promise<ITransformation[]> {
        let json : string = "";
        if (idCompany === EMPTY_GUID) {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithOnlyCompleted(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var transformations: ITransformation[] = [];
            transformations = response.data as ITransformation[];
            return transformations;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveTransformation(transformation: ITransformation) : Promise<string> {
        const json = this.getJsonSave(transformation);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateTransformation(transformation: ITransformation) : Promise<boolean> {
        const json = this.getJsonUpdate(transformation);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteTransformation(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonCompleteTransformation(idTransformation: string): any {
        const json = {
            "spname": "dbo.TRANSFORM_PALLETS",
            "parameters": [{
                "Item1": "IdTransformation",
                "Item2": idTransformation
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "conditions": [{
                "Item1": "transformations",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }],
            "table": "transformations"
        };
        return json;
    }

    private getJsonSave(transformation: ITransformation) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idCompanySource",
                "Item2": transformation.idCompanySource
            }, {
                "Item1": "idCompanyDestination",
                "Item2": transformation.idCompanyDestination
            }, {
                "Item1": "idCustomer",
                "Item2": transformation.idCustomer
            }, {
                "Item1": "idListStatusTransformation",
                "Item2": transformation.idListStatusTransformation
            }, {
                "Item1": "idInbound",
                "Item2": transformation.idInbound
            }, {
                "Item1": "idWarehouse",
                "Item2": transformation.idWarehouse
            }, {
                "Item1": "dateTransform",
                "Item2": transformation.dateTransform
            }, {
                "Item1": "inboundCode",
                "Item2": transformation.inboundCode
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "transformations"
        };
        return json;
    }

    private getJsonUpdate(transformation: ITransformation) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idCompanySource",
                "Item2": transformation.idCompanySource
            }, {
                "Item1": "idCompanyDestination",
                "Item2": transformation.idCompanyDestination
            }, {
                "Item1": "idCustomer",
                "Item2": transformation.idCustomer
            }, {
                "Item1": "idListStatusTransformation",
                "Item2": transformation.idListStatusTransformation
            }, {
                "Item1": "idInbound",
                "Item2": transformation.idInbound
            }, {
                "Item1": "idWarehouse",
                "Item2": transformation.idWarehouse
            }, {
                "Item1": "dateTransform",
                "Item2": transformation.dateTransform
            }, {
                "Item1": "inboundCode",
                "Item2": transformation.inboundCode
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "transformations",
            "keyvalue": transformation.id
        };
        return json;
    }

    private getJsonReadWithOnlyCompleted(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "transformations",
                "Item2": "id"
            }, {
                "Item1": "transformations",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "transformations",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "transformations",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "Name as customerSourceName"
            }, {
                "Item1": "transformations",
                "Item2": "dateTransform"
            }, {
                "Item1": "transformations",
                "Item2": "idInbound"
            }, {
                "Item1": "transformations",
                "Item2": "inboundCode"
            }, {
                "Item1": "transformations",
                "Item2": "idListStatusTransformation"
            }, {
                "Item1": "ListStatusTransformation",
                "Item2": "Name as statusName"
            }, {
                "Item1": "transformations",
                "Item2": "idWarehouse"
            }, {
                "Item1": "Warehouses",
                "Item2": "Name as warehouseName"
            }],
            "tables": [{
                "Item1": "transformations"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "customers"
            }, {
                "Item1": "liststatustransformation"
            }],
            "conditions": [{
                "Item1": "transformations",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "transformations",
                "Item2": "idListStatusTransformation",
                "Item3": "IN",
                "Item4": "(SELECT ID FROM ListStatusTransformation WHERE Name = 'Completed')",
                "Item5": "AND"
            }, {
                "Item1": "(transformations",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "transformations",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }],
            "joins": [{
                "Item1": "transformations",
                "Item2": "IdWarehouse",
                "Item3": "warehouses",
                "Item4": "Id"
            }, {
                "Item1": "transformations",
                "Item2": "IdCustomer",
                "Item3": "customers",
                "Item4": "Id"
            }, {
                "Item1": "transformations",
                "Item2": "idListStatusTransformation",
                "Item3": "liststatustransformation",
                "Item4": "Id"
            }]
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "transformations",
                "Item2": "id"
            }, {
                "Item1": "transformations",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "transformations",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "transformations",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "Name as customerSourceName"
            }, {
                "Item1": "transformations",
                "Item2": "dateTransform"
            }, {
                "Item1": "transformations",
                "Item2": "idInbound"
            }, {
                "Item1": "transformations",
                "Item2": "inboundCode"
            }, {
                "Item1": "transformations",
                "Item2": "idListStatusTransformation"
            }, {
                "Item1": "ListStatusTransformation",
                "Item2": "Name as statusName"
            }, {
                "Item1": "transformations",
                "Item2": "idWarehouse"
            }, {
                "Item1": "Warehouses",
                "Item2": "Name as warehouseName"
            }],
            "tables": [{
                "Item1": "transformations"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "customers"
            }, {
                "Item1": "liststatustransformation"
            }],
            "conditions": [{
                "Item1": "transformations",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "transformations",
                "Item2": "IdListStatusTransformation",
                "Item3": "NOT IN",
                "Item4": "(SELECT ID FROM ListStatusTransformation WHERE Name = 'Completed')"
            }],
            "joins": [{
                "Item1": "transformations",
                "Item2": "IdWarehouse",
                "Item3": "warehouses",
                "Item4": "Id"
            }, {
                "Item1": "transformations",
                "Item2": "IdCustomer",
                "Item3": "customers",
                "Item4": "Id"
            }, {
                "Item1": "transformations",
                "Item2": "idListStatusTransformation",
                "Item3": "liststatustransformation",
                "Item4": "Id"
            }]
        };
        return json;
    }

    private getJsonReadWithIdCompany(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "transformations",
                "Item2": "id"
            }, {
                "Item1": "transformations",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "transformations",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "transformations",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "Name as customerSourceName"
            }, {
                "Item1": "transformations",
                "Item2": "dateTransform"
            }, {
                "Item1": "transformations",
                "Item2": "idInbound"
            }, {
                "Item1": "transformations",
                "Item2": "inboundCode"
            }, {
                "Item1": "transformations",
                "Item2": "idListStatusTransformation"
            }, {
                "Item1": "ListStatusTransformation",
                "Item2": "Name as statusName"
            }, {
                "Item1": "transformations",
                "Item2": "idWarehouse"
            }, {
                "Item1": "Warehouses",
                "Item2": "Name as warehouseName"
            }],
            "tables": [{
                "Item1": "transformations"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "customers"
            }, {
                "Item1": "liststatustransformation"
            }],
            "conditions": [{
                "Item1": "transformations",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "transformations",
                "Item2": "IdListStatusTransformation",
                "Item3": "NOT IN",
                "Item4": "(SELECT ID FROM ListStatusTransformation WHERE Name = 'Completed')",
                "Item5": "AND"
            }, {
                "Item1": "(transformations",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "transformations",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }],
            "joins": [{
                "Item1": "transformations",
                "Item2": "IdWarehouse",
                "Item3": "warehouses",
                "Item4": "Id"
            }, {
                "Item1": "transformations",
                "Item2": "IdCustomer",
                "Item3": "customers",
                "Item4": "Id"
            }, {
                "Item1": "transformations",
                "Item2": "idListStatusTransformation",
                "Item3": "liststatustransformation",
                "Item4": "Id"
            }]
        };
        return json;
    }
}
